export enum BeatTypes {
    independent = 'independent',
    music_label = 'music_label'
}
export enum UploadTypes {
    Wav = 'wav',
    coverImage ='cover-picture',
    Mp3 = 'preview',
    Stem = 'stem'
}

export enum  uploadType {
    musicUpload = 'musicUpload',
    coverImageUpload = 'coverImageUpload',
    wavFileUpload = 'wavFileUpload',
    stemUpload = 'stemUpload'
}

export enum PriceMode {
    Manual = 'manual',
    Auto = 'auto'
}

export enum DiscountedPrice {
    Rupee = 'rupee', 
    Percentage = 'percentage' 
}

export enum LicenseSlug {
    Wav = 'wav',
    WavStem = 'wav_stem',
    Mp3 = 'mp3',
    Exclusive = 'exclusive',
    WavForm = 'wavForm',
    WavStemForm = 'wav_stemForm',
    Mp3Form = 'mp3Form',
    ExclusiveForm = 'exclusiveForm',
}

export enum ProducerStatus {
    Approved = 'approved',
    Rejected = 'rejected',
    YetToApprove = 'yet-to-approve',
    Verified = 'is_verfied'
}

export enum DownloadableReadUrlType {
    Preview = 'preview', 
    Wav = 'wav', 
    Stem = 'stem'
}